import { useState } from 'react';
import axios from 'axios';

const API = '/api';

function Login({ onLogin, onGoRegister }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('token', res.data.token);
      onLogin(res.data.token);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@300;400;500&family=DM+Sans:wght@300;400;500&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'DM Sans', sans-serif; background: #f7f6f3; }
        .auth-wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; }
        .auth-card { background: #fff; border: 1px solid #e8e6e1; border-radius: 6px; padding: 40px; width: 380px; }
        .auth-logo { font-family: 'DM Mono', monospace; font-size: 20px; font-weight: 500; margin-bottom: 8px; }
        .auth-logo span { color: #2563eb; }
        .auth-subtitle { font-family: 'DM Mono', monospace; font-size: 11px; color: #9b9690; letter-spacing: 0.5px; margin-bottom: 32px; }
        .auth-label { font-size: 11px; font-family: 'DM Mono', monospace; color: #9b9690; letter-spacing: 0.5px; text-transform: uppercase; display: block; margin-bottom: 5px; }
        .auth-input { width: 100%; padding: 8px 10px; border: 1px solid #e8e6e1; border-radius: 4px; background: #f7f6f3; font-family: 'DM Sans', sans-serif; font-size: 13px; color: #1a1917; outline: none; transition: border-color 0.15s; }
        .auth-input:focus { border-color: #2563eb; background: white; }
        .auth-field { margin-bottom: 14px; }
        .auth-btn { width: 100%; padding: 9px; background: #1a1917; color: white; border: none; border-radius: 4px; cursor: pointer; font-family: 'DM Sans', sans-serif; font-size: 13px; font-weight: 500; margin-top: 6px; transition: opacity 0.15s; }
        .auth-btn:hover { opacity: 0.85; }
        .auth-error { font-family: 'DM Mono', monospace; font-size: 11px; color: #dc2626; margin-bottom: 12px; }
        .auth-switch { margin-top: 20px; text-align: center; font-family: 'DM Mono', monospace; font-size: 11px; color: #9b9690; border-top: 1px solid #e8e6e1; padding-top: 20px; }
        .auth-switch span { color: #2563eb; cursor: pointer; }
        .auth-switch span:hover { text-decoration: underline; }
      `}</style>
      <div className="auth-wrap">
        <div className="auth-card">
          <div className="auth-logo">fin<span>trak</span></div>
          <div className="auth-subtitle">sign in to your account</div>
          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label className="auth-label">Email</label>
              <input className="auth-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
            </div>
            <div className="auth-field">
              <label className="auth-label">Password</label>
              <input className="auth-input" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            {error && <div className="auth-error">{error}</div>}
            <button type="submit" className="auth-btn">Sign in</button>
          </form>
          <div className="auth-switch">
            no account? <span onClick={onGoRegister}>register</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;